<template>
  <div class="h-[2rem]" v-if="loading"></div>
  <section
    v-else
    class="flex justify-center flex-col p-20 w-full"
    aria-labelledby="table-empty-title"
  >
    <div class="flex items-center justify-center">
      <CustomImage :src="emptyImage" class="max-w-[20rem]" />
    </div>

    <div class="flex items-center justify-center mt-6">
      <h3 id="table-empty-title" class="font-normal text-[1.5rem] tracking-[0.36px]">
        {{ emptyMessage }}
      </h3>
    </div>

    <div class="flex items-center justify-center mt-6" v-if="$slots.extraEmptyInfo">
      <slot name="extraEmptyInfo" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { Image as CustomImage } from './../../media';
import EmptyImageState from './../../data/data-table/assets/fl-empty.svg';
defineProps({
  emptyMessage: {
    type: String,
    default: 'No data found',
  },
  loading: {
    type: Boolean,
  },
  emptyImage: {
    type: String,
    default: EmptyImageState,
  },
});
</script>

<style scoped lang="scss"></style>
